import formContent from "../FormLocalSearch/content";

// Texts of the local SERP checker results. `googleDomain` and `hl` build the
// Google result links: google.fr in French, google.com in English.
const content = {
  fr: {
    googleDomain: "www.google.fr",
    hl: "fr",
    title: "Voici vos résultats de recherche hyper localisé",
    subtitle: "Cliquez sur la page de votre choix et découvrez le classement.",
    summaryTitle: "Résumé de votre requête",
    query: "Requête",
    location: "Localisation",
    country: "Pays",
    searchEngine: "Moteur de recherche",
    colon: " :",
    googleSearch: "Recherche Google",
    googleMaps: "Google Maps",
    countries: formContent.fr.countries,
  },
  en: {
    googleDomain: "www.google.com",
    hl: "en",
    title: "Here are your local search results",
    subtitle: "Click any page number to see the rankings for that location.",
    summaryTitle: "Your search",
    query: "Search term",
    location: "Location",
    country: "Country",
    searchEngine: "Search engine",
    colon: ":",
    googleSearch: "Google Search",
    googleMaps: "Google Maps",
    countries: formContent.en.countries,
  },
};

export default content;
